<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>Event type</mat-label>
    <mat-select id="event-types" multiple formControlName="eventTypeGroups">
      <mat-option *ngFor="let option of eventTypeGroupNames" [value]="option.id" [title]="option.name">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <eas-editor-eligibility-blueprints-form
    [blueprintsFormArray]="getBlueprintsFormArray()"
  >
  </eas-editor-eligibility-blueprints-form>
  <fieldset>
    <legend>
      <div>
        <span i18n>Date filter</span>
      </div>
    </legend>
    <p i18n>
      In this date interval
    </p>
    <div class="form-container">
      <mat-form-field appearance="outline" class="form-date-start">
        <mat-label i18n>From</mat-label>
        <input matInput [matDatepicker]="start" id="start" formControlName="start">
        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
        <mat-datepicker #start></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-date-end">
        <mat-label i18n>To</mat-label>
        <input matInput [matDatepicker]="end" id="end" formControlName="end">
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
    </div>
    <p i18n>
      In the last
    </p>
    <div class="form-container">
      <mat-form-field appearance="outline" class="form-years">
        <mat-label i18n>Years</mat-label>
        <input matInput type="number" formControlName="relativeStartYears">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-months">
        <mat-label i18n>Months</mat-label>
        <input matInput type="number" formControlName="relativeStartMonths">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-days">
        <mat-label i18n>Days</mat-label>
        <input matInput type="number" formControlName="relativeStartDays">
      </mat-form-field>
    </div>
  </fieldset>
</ng-container>
